import { useQuery } from '@tanstack/react-query'
import { helpArticleQuery } from './hooks'

/** Breadcrumb for /help/$slug: the article title once loaded. */
export function ArticleCrumb({ params }: { params: Record<string, string> }) {
  const slug = params.slug ?? ''
  const q = useQuery({ ...helpArticleQuery(slug), enabled: !!slug })
  return <span>{q.data?.title ?? slug}</span>
}
